import React, { useState, useEffect } from "react";
import ErrorMessage from "../../Components/ErrorMessage";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";

const NewProject = () => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const navigate = useNavigate();
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const [projectName, setProjectName] = useState("");
    const [projectDescription, setProjectDescription] = useState("");

    const goBack = () => {
        navigate("/control_panel/projects");
    };


    const handleSave = async () => {
        if (!projectName.trim()) {
            setErr({ message: t.projects.new_project.err_name, display: true });
            return;
        }
        if (!projectDescription.trim()) {
            setErr({ message: t.projects.new_project.err_desc, display: true });
            return;
        }

        setErr({ message: "", display: false });

        const data = {
            user_id,
            project_name: projectName,
            project_description: projectDescription,
        };


        try {
            setLoading(true);
            const response = await fetch("https://backend.erioon.com/save_project", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            setLoading(false);

            if (response.ok) {
                const result = await response.json();
                const project_id = result.project_id
                navigate(`/project_panel/${project_id}/databases`);
                // navigate(`/initialize_loading/${user_id}/${project_id}`);
            } else {
                setErr({
                    message: t.err_save_general,
                    display: true,
                });
            }
        } catch (error) {
            setLoading(false);
            setErr({
                message: t.err_save_general,
                display: true,
            });
        }
    };


    return (
        <div className="new_section_main_view">
            <p className="new_section_main_view_title fade-in">
                <i
                    className="fa-solid fa-chevron-left"
                    onClick={goBack}
                ></i>{" "}
                {t.projects.new_project.title}
            </p>
            <p className="new_section_main_view_subtitle fade-in">
                {t.projects.new_project.subtitle}
            </p>

            <div className="new_section_main_input_cont fade-in">
                <div className="new_section_main_input_container ">
                    <div className="new_input_field_cont">
                        <div className="label_input_section">
                            <label>{t.projects.new_project.name}</label>
                            <input
                                placeholder={t.projects.new_project.placeholder_name}
                                value={projectName}
                                onChange={(e) => setProjectName(e.target.value)}
                            />
                        </div>
                        <div className="label_input_section">
                            <label>{t.projects.new_project.description}</label>
                            <textarea
                                className="description_area_input"
                                placeholder={t.projects.new_project.placeholder_desc}
                                value={projectDescription}
                                onChange={(e) => setProjectDescription(e.target.value)}
                            />
                        </div>
                        <ErrorMessage err={err} />
                        <button className="save_btn" onClick={() => handleSave()}>
                            {loading ? (
                                <Spinner loading={loading} />
                            ) : (
                                <>{t.save}</>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewProject;
